const ROUTES = {
  // === ACCOUNT ERR-928 ===
  ACCOUNT_PREFERENCES: "/form/:idTemplate/:formPage",
  // === ACCOUNT: ERR-928 ===
  ACTIVITY_LOG_CONTACT_LOG: "/activity-log/contact-log",
  ACTIVITY_LOG_GENERAL: "/activity-log/general",
  ACTIVITY_LOG_HARBOR_CARE: "/activity-log/harbor-care",
  ACTIVITY_LOG_HARM_REDUCTION: "/activity-log/harm-reduction",
  ACTIVITY_LOG_PJR: "/activity-log/pjr",
  ACTIVITY_LOG_VOLUNTEER: "/activity-log/volunteer",
  ACTIVITY_LOG_EMPLOYER_CONTACT: "/activity-log/employer",
  APPOINTMENTS: "/appointments",
  AUDIT_LOG: "/organization/audit-log",
  BLOCK_ADD: "/block/add",
  BLOCK_CLONE: "/block/customize/:idBlock",
  BLOCK_EDIT: "/block/edit/:idBlock",
  BLOCK_ASSESSMENT_ADD: "/block/assessment/add/:idBlock",
  BLOCK_ASSESSMENT_CUSTOMIZE: "/block/assessment/customize/:idBlock",
  BLOCK_ASSESSMENT_EDIT: "/block/assessment/edit/:idBlock",
  COORDINATION_BOARD: "/coordination-board",
  COORDINATION_BOARD_VIEW: "/coordination-board/:idBoard/:idTopic",
  EXTERNAL_CALLS: "/external-calls",
  CUSTOM_ACTIVITY_TEMPLATE_1: "/activity-log/custom_activity_template_1",
  CUSTOM_ACTIVITY_TEMPLATE_2: "/activity-log/custom_activity_template_2",
  CUSTOM_FORM_TEMPLATE_1:
    "/participant/custom-data-form/custom_form_template_1",
  CUSTOM_FORM_TEMPLATE_2:
    "/participant/custom-data-form/custom_form_template_2",
  CUSTOM_SESSION_TEMPLATE_1:
    "/participant/engagements/custom_session_template_1",
  CUSTOM_SESSION_TEMPLATE_2:
    "/participant/engagements/custom_session_template_2",
  DATA_DICTIONARIES: "/actions/data-dictionaries",
  DEMO_PAGE: "/demo-page",
  DEMO_PHONE_PAGE: "/demo-phone-page",
  DENIED: "/denied",
  ENTERPRISES_LIST: "admin/enterprises",
  ENTERPRISE_ADD: "/enterprise/add",
  ENTERPRISE_EDIT: "/enterprise/edit/:idEnterprise",
  FORM_EDIT: "/form/:idTemplate/:formPage/:idStamp",
  FORM_PAGE: "/form/:idTemplate/:formPage",
  FORM_USER_ENTERPRISE_EDIT: "/:type/form/:idTemplate/:formPage/:idStamp",
  FORM_USER_ENTERPRISE_PAGE: "/:type/form/:idTemplate/:formPage",
  FORM_USER_ORGANIZATION_EDIT: "/:type/form/:idTemplate/:formPage/:idStamp",
  FORM_USER_ORGANIZATION_PAGE: "/:type/form/:idTemplate/:formPage",
  FORM_USER_ORG_AND_ENT_EDIT: "/:type/form/:idTemplate/:formPage/:idStamp",
  FORM_USER_ORG_AND_ENT_PAGE: "/:type/form/:idTemplate/:formPage",
  FORM_VIEW_MODE: "/form/view/:idTemplate/:idStamp",
  STAFF_FORM_VIEW: "/admin/users/:userId",
  GPRA_DEMOGRAPHICS_INTAKE: "intake/demographics",
  GPRA_DISCHARGE_DISCHARGE: "discharge/discharge",
  GPRA_DISCHARGE_START: "discharge/start",
  GPRA_EDUCATION_DISCHARGE: "discharge/education",
  GPRA_EDUCATION_FOLLOWUP: "followUp/education",
  GPRA_EDUCATION_INTAKE: "intake/education",
  GPRA_FAMILY_DISCHARGE: "discharge/family",
  GPRA_FAMILY_FOLLOWUP: "followUp/family",
  GPRA_FAMILY_INTAKE: "intake/family",
  GPRA_FOLLOWUP_FOLLOWUP: "followUp/followUp",
  GPRA_FOLLOWUP_START: "followUp/start",
  GPRA_LEGAL_DISCHARGE: "discharge/legal",
  GPRA_LEGAL_FOLLOWUP: "followUp/legal",
  GPRA_LEGAL_INTAKE: "intake/legal",
  GPRA_MENTAL_DISCHARGE: "discharge/mental",
  GPRA_MENTAL_FOLLOWUP: "followUp/mental",
  GPRA_MENTAL_INTAKE: "intake/mental",
  GPRA_PLANNED_SERVICES1_DISCHARGE: "discharge/plannedServices1",
  GPRA_PLANNED_SERVICES1_FOLLOWUP: "followUp/plannedServices1",
  GPRA_PLANNED_SERVICES1_INTAKE: "intake/plannedServices1",
  GPRA_PLANNED_SERVICES2_DISCHARGE: "discharge/plannedServices2",
  GPRA_PLANNED_SERVICES2_FOLLOWUP: "followUp/plannedServices2",
  GPRA_PLANNED_SERVICES2_INTAKE: "intake/plannedServices2",
  GPRA_PLANNED_SERVICES3_DISCHARGE: "discharge/plannedServices3",
  GPRA_PLANNED_SERVICES3_FOLLOWUP: "followUp/plannedServices3",
  GPRA_PLANNED_SERVICES3_INTAKE: "intake/plannedServices3",
  GPRA_PLANNED_SERVICES4_DISCHARGE: "discharge/plannedServices4",
  GPRA_PLANNED_SERVICES4_FOLLOWUP: "followUp/plannedServices4",
  GPRA_PLANNED_SERVICES4_INTAKE: "intake/plannedServices4",
  GPRA_PROGRAM_QUESTIONS_DISCHARGE: "discharge/program",
  GPRA_PROGRAM_QUESTIONS_FOLLOWUP: "followUp/program",
  GPRA_RECORDMGMT: "recordMgmt",
  GPRA_SERVICESRECEIVED1_DISCHARGE: "discharge/servicesReceived1",
  GPRA_SERVICESRECEIVED2_DISCHARGE: "discharge/servicesReceived2",
  GPRA_SERVICESRECEIVED3_DISCHARGE: "discharge/servicesReceived3",
  GPRA_SERVICESRECEIVED4_DISCHARGE: "discharge/servicesReceived4",
  GPRA_SERVICESRECEIVED5_DISCHARGE: "discharge/servicesReceived5",
  GPRA_SOCIAL_DISCHARGE: "discharge/social",
  GPRA_SOCIAL_FOLLOWUP: "followUp/social",
  GPRA_SOCIAL_INTAKE: "intake/social",
  GPRA_SUBSTANCE_USE1_DISCHARGE: "discharge/substanceUse1",
  GPRA_SUBSTANCE_USE1_FOLLOWUP: "followUp/substanceUse1",
  GPRA_SUBSTANCE_USE1_INTAKE: "intake/substanceUse1",
  GPRA_SUBSTANCE_USE2_DISCHARGE: "discharge/substanceUse2",
  GPRA_SUBSTANCE_USE2_FOLLOWUP: "followUp/substanceUse2",
  GPRA_SUBSTANCE_USE2_INTAKE: "intake/substanceUse2",
  GPRA_SUBSTANCE_USE3_DISCHARGE: "discharge/substanceUse3",
  GPRA_SUBSTANCE_USE3_FOLLOWUP: "followUp/substanceUse3",
  GPRA_SUBSTANCE_USE3_INTAKE: "intake/substanceUse3",
  GPRA_SUMMARY_DISCHARGE: "discharge/summary",
  GPRA_SUMMARY_FOLLOWUP: "followUp/summary",
  GPRA_SUMMARY_INTAKE: "intake/summary",
  GROUP_SESSION_LIST: "/group-session",
  GROUP_SUPERVISION_SESSIONS: "/supervision/group-session",
  HOMEPAGE: "/",
  DASHBOARD: "/dashboard",
  LIBRARY_ADD: "/library/add",
  LIBRARY_BLOCKS: "/library/blocks",
  LIBRARY_CLONE: "/library/customize/:idField",
  LIBRARY_COORDINATION_BOARDS: "/library/coordination-boards",
  LIBRARY_DOCUMENT_SIGNING: "/library/documents",
  LIBRARY_ENTERPRISE_PROFILE: "/library/:idTemplate/:formPage/:idStamp",
  LIBRARY_FIELDS: "/enterprise/library",
  LIBRARY_FIELDS_ADD: "/library/field/add",
  LIBRARY_FIELDS_EDIT: "/library/field/edit/:idField",
  LIBRARY_GPRA: "/library/gpra",
  LIBRARY_HOUSING: "/library/housing",
  LIBRARY_TEMPLATES: "/library/templates",
  LOCATIONS_LIST: "/enterprise/locations",
  ORGANIZATION_LOCATIONS_LIST: "/organization/locations",
  LIBRARY_ASSESSMENTS: "/library/assessments",
  LIBRARY_TELERECOVERY: "/library/telerecovery",
  LIBRARY_TELERECOVERY_ORG: "/library/telerecovery/:organizationId",
  LIBRARY_KIOSK: "/library/kiosk",
  LOCATION_ADD_ORGANIZATION: "/organization/locations/add",
  LOCATION_ADD_ENTERPRISE: "/enterprise/locations/add",
  LOCATION_EDIT_ORGANIZATION: "/organization/location/edit/:idLocation",
  LOCATION_EDIT_ENTERPRISE: "/enterprise/location/edit/:idLocation",
  MY_APPOINTMENTS: "/my-appointments",
  MY_CALENDAR: "/my-calendar",
  MY_PROFILE: "/account/edit/",
  NOTES_LIST: "/participant/notes",
  ORDERED_REPORTS: "/actions/ordered-reports",
  ORGANIZATION_ADD: "/organization/add",
  ORGANIZATION_CALENDAR: "/organization-calendar",
  ORGANIZATION_EDIT: "/organization/edit/:idOrganization",

  ORGANIZATION_PROGRAM_LIST: "/organization/programs",
  ORGANIZATION_REPORTS: "/actions/organization-reports",
  ORGANIZATION_STAFF: "/organization-staff",
  // =====STAFF: ERR-38=====
  ENTERPRISE_STAFF_PROFILE: "enterprise/staff/profile",
  ORGANIZATION_STAFF_PROFILE: "organization/staff/profile",
  ORGANIZATION_STAFF_SUPERVISION_PLAN: "organization/staff/supervision-plan",
  ORGANIZATION_STAFF_INDIVIDUAL_SESSION:
    "organization/staff/supervision-session/individual",
  ORGANIZATION_STAFF_GROUP_SESSION:
    "organization/staff/supervision-session/group",
  ORGANIZATION_STAFF_DOCUMENTS: "organization/staff/documents",
  // =====STAFF: ERR-38=====
  ORGANIZATION_USER_LIST: "organization/staff",
  ORGANIZATION_USER_LIST_FILTER: "organization/staff/:idFilter",
  ORGANIZATIONS_LIST: "/enterprise/organizations",
  ORGANIZATIONS_LIST_DEFAULT: "/organization/list/:idEnterprise",
  ORGANIZATIONS_LIST_FILTER: "/enterprise/organizations/:idEnterprise",
  PARTICIPANT_ACCOUNT_INFORMATION: "/participant/account_information/",
  PARTICIPANT_ADD: "/participant/add",
  PARTICIPANT_CUSTOM_DATA_FORMS: "/participant/custom-data-forms",
  PARTICIPANT_CUSTOM_DF_AD_HOC_8:
    "/participant/custom-data-form/ad-hoc-8-dimensions",
  PARTICIPANT_CUSTOM_DF_HEP_AB: "/participant/custom-data-form/hep-ab",
  PARTICIPANT_CUSTOM_DF_HEP_C: "/participant/custom-data-form/hep-c",
  PARTICIPANT_CUSTOM_DF_HOUSING_ASSISTNACE:
    "/participant/custom-data-form/housing_assistance",
  PARTICIPANT_CUSTOM_DF_INSURANCE_STATUS:
    "/participant/custom-data-form/insurance_status",
  PARTICIPANT_CUSTOM_DF_REAL_D: "/participant/custom-data-form/real-d",
  PARTICIPANT_CUSTOM_DF_REAL_LYFT_ASSESSMENT:
    "/participant/custom-data-form/lyft-assessment",
  PARTICIPANT_DISCHARGE: "/participant/discharge",

  PARTICIPANT_ASSESSMENTS: "/participant/assessments",
  PARTICIPANT_ENGAGEMENTS_MANAGE_SERVICES:
    "/participant/engagements/manage-services",

  PARTICIPANT_ENGAGEMENTS_MANAGE_SERVICES_EPISODES:
    "/participant/manage/service-episodes",

  PARTICIPANT_ENGAGEMENTS_MANAGE_SERVICES_EPISODE:
    "/participant/manage/service-episode/:service_episode_id",

  PARTICIPANT_ENGAGEMENTS_HOMEPAGE: "/participant/engagements",
  PARTICIPANT_ENGAGEMENTS_RECOVERY_PLANNING_SESSION:
    "/participant/engagements/recovery-planning-session",
  PARTICIPANT_DOCUMENTS: "/participant/documents",
  PARTICIPANT_DOCUMENT_FORM: "/form/document_record_participant/1/",
  PARTICIPANT_ENGAGED_SERVICES: "/participant/engaged_services/",
  PARTICIPANT_ENGAGEMENTS: "/participant/engagements",
  PARTICIPANT_ENGAGEMENTS_BRIEF_C: "/participant/engagements/brief-checkin",
  PARTICIPANT_ENGAGEMENTS_CARE_C: "/participant/engagements/care-coordination",

  PARTICIPANT_ENGAGEMENTS_NICU: "/participant/engagements/nicu",
  PARTICIPANT_ENGAGEMENTS_PLAN_SELF_CARE:
    "/participant/engagements/plan-self-care",

  PARTICIPANT_EMPLOYMENT_CAREER: "/participant/employment/career",
  PARTICIPANT_EMPLOYMENT_SERVICES: "/participant/employment",
  PARTICIPANT_GPRA_FORMS: "/participant/gpra-forms",
  PARTICIPANT_LIST: "/participant/list",
  PARTICIPANT_MANAGE_SERVICES: "/form/manage_services/1/",
  PARTICIPANT_MYPARTICIPANTS: "/my-participants",
  PARTICIPANT_PROFILE: "/participant/profile/",
  PARTICIPANT_RECOVERY_CAPITAL: "/participant/recovery-capital",
  PARTICIPANT_RECOVERY_PLAN: "/participant/recovery-plan",
  PARTICIPANT_REFERRAL_EDIT: "/participant/referrals/edit/:id",
  PARTICIPANT_REFERRAL_ENTITIES: "/participant/referral-entities",
  PARTICIPANT_REFERRAL_ENTITIES_ADD: "/participant/referral-entities/add",
  PARTICIPANT_REFERRAL_ENTITIES_EDIT: "/participant/referral-entities/edit/:id",
  PARTICIPANT_REFERRALS: "/participant/referrals",
  PARTICIPANT_SETUP: "/participant/setup",
  PARTICIPANT_TELERECOVERY_SERVICES: "/participant/telerecovery-services",
  PARTNER_ENTITY_ADD_STAFF: "/partner/add",
  PARTNER_ENTITY_EDIT_STAFF: "/partner/edit/:idUser",
  PARTNER_ENTITY_PROFILE: "/partner/profile",
  PARTNER_ENTITY_STAFF: "/partner/staff",
  PROFILE_EDIT: "/account/edit",
  PROFILE_2FA: "/account/2fa/settings",
  PROGRAMS_ASSIGN: "/program/assign/:idProgram",
  PROGRAMS_LIST: "/enterprise/programs",
  REFERRAL_ADD: "/referrals/add",
  REFERRAL_EDIT: "/referrals/edit/:id",
  REFERRAL_ENTITIES: "/partner/entities",
  REFERRAL_ENTITY_ADD: "/partner/entity/add",
  REFERRAL_ENTITY_EDIT: "/partner/entity/edit/:id",
  REFERRAL_ENTITY_MAP: "/partner/map",
  REFERRAL_ENTITY_USER_ADD: "/partner/staff/add",
  REFERRAL_ENTITY_USER_EDIT: "/partner/staff/edit/:id",
  REFERRAL_NETWORK_ORG: "/referral-network",
  REFERRAL_NETWORKS: "/enterprise/referrals",
  REFERRALS: "/referrals",
  REFERRALS_LIST: "/referrals/list",
  STAFF_DASHBOARD: "/my-dashboard",
  STAFF_DOCUMENTS: "/staff/documents",
  STAFF_LIST: "/staff/list",
  STAFF_SCHEDULING: "/staff-scheduling",
  SUPERVISION_PLAN_LIST: "/supervision-plan/list",
  SUPERVISION_SESSION_LIST: "/supervision-session/list",
  SUPERVISION_SESSION_STAFF: "/supervision-session/staff",
  SUPERVISION_SESSION_SUPERVISOR: "/supervision/individual-session",
  SUPERVISOR_DASHBOARD: "/supervisor-dashboard",
  TELERECOVERY_GLOBAL_MESSAGES: "/global-messages",
  TEMPLATE_ADD: "/template/add",
  TEMPLATE_CLONE: "/template/customize/:idTemplate",
  TEMPLATE_EDIT: "/template/edit/:idTemplate",
  USER_LIST: "/enterprise/staff",
  USER_LIST_FILTER: "/enterprise/staff/:idFilter",
  USERS_LIST_ADMIN: "/admin/users",
  KIOSK_DASHBOARD: "/kiosk-dashboard",
}

export default ROUTES
